import React from 'react'

class E404 extends React.Component {
  render() {
    return (
      <div className="e404">
        <div className="e404__top">
          <div className="wd">
            <h1 className="e404__heading">404</h1>
            <p className="e404__description">На жаль, ми не знайшли таку сторiнку :(</p>
            <a href="/" className="e404__tomain">На головну сторiнку</a>
          </div>
        </div>
        <img src="/img/dzyga.png" className="e404__dzyga" alt=""/>
      </div>
    )
  }
}

export default E404


// WEBPACK FOOTER //
// ./src/components/pages/e404/e404.jsx